import { useEffect } from "react";
import { db } from "../../firebase/config";
import { useDispatch, useSelector } from "react-redux";
import { usedHooks } from "../../store/site/selectors";
import { addUsedHook } from "../../store/site/actions/addUsedHook";
import { TalesProgramma } from "../types/TalesProgramma";
import { setProgrammaData } from "../../store/programma/actions/setData";
import { setProgrammaError } from "../../store/programma/actions/setError";

export default function useProgrammi() {
  const dispatch = useDispatch();
  const hooks = useSelector(usedHooks);

  useEffect(() => {
    if (!hooks.includes("useProgrammi")) {
      dispatch(addUsedHook("useProgrammi"));
      db.collection("programma")
        .orderBy("order")
        .onSnapshot((snapshot) => {
          if (snapshot.empty) {
            dispatch(setProgrammaError("Non è stata trovata nessun programma"));
          } else {
            let programmi: TalesProgramma[] = [];
            snapshot.docs.forEach((doc) => {
              programmi = [...programmi, doc.data() as TalesProgramma];
            });
            dispatch(setProgrammaData(programmi));
          }
        });
    }
  }, [dispatch, hooks]);
}
